import * as React from 'react'
import type { NetworkStatus } from '@apollo/client'
import { debounce } from 'lodash'

import { Catalog } from '~/components'
import type { IProduct } from '~/types/products'

import { ContentLayout } from '../content-layout'

export interface ContentMobileProps {
  products: IProduct[]
  networkStatus: NetworkStatus
  paginationInfo: IPagination
  paginationType?: 'infinite' | 'pages'
  onFetchMoreProducts: (page: number) => void
}

export function ContentMobile(props: ContentMobileProps) {
  const { products, networkStatus, paginationInfo, paginationType = 'infinite', onFetchMoreProducts } = props

  return (
    <ContentLayout
      dataSource={products}
      networkStatus={networkStatus}
      render={() => (
        <Catalog
          products={products}
          paginationType={paginationType}
          pageInfo={paginationInfo}
          pagination={
            paginationType === 'infinite'
              ? {
                  pageStart: paginationInfo.page ?? 1, // need to specify correct page from pagination info when the user has navigated to another page and then goes back and continue scrolling to avoid loading duplicated products
                  hasMore: paginationInfo.hasNextPage,
                  initialLoad: true,
                  loadMore: debounce(onFetchMoreProducts, 500), // When the debounce is removed, the package requests page 2 and 3 when it should only request page 2
                }
              : undefined
          }
        />
      )}
    />
  )
}
